import { MethodCommands, MethodHandler, MethodProperties } from '@lentau/analytics/health-metrics/shared';
import { getCategoryHandler } from './categories-method-handlers';
import { MethodPropertiesKey } from '../../shared/consts';

export enum CategoryMethods {
  GetCategory = 'goodsCategorySearch',
}
export const CATEGORY_HANDLER_LIST: MethodHandler = {
  [CategoryMethods.GetCategory]: getCategoryHandler,
};

export const CATEGORY_PROPERTIES_LIST: MethodProperties = new Map([
  [
    CategoryMethods.GetCategory,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.SE,
      },
    ],
  ],
]);
